import { render, staticRenderFns } from "./userMyCourse.vue?vue&type=template&id=0a998b1a&scoped=true"
import script from "./userMyCourse.vue?vue&type=script&lang=js"
export * from "./userMyCourse.vue?vue&type=script&lang=js"
import style0 from "./userMyCourse.vue?vue&type=style&index=0&id=0a998b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a998b1a",
  null
  
)

export default component.exports